import PropTypes from 'prop-types';
import React, { useState } from 'react';
import MyContext from './MyContext';

export default function Provider({ children }) {
  const [language, setLanguage] = useState('english');
  const [checked, setChecked] = useState(true);

  const stateAndFunctions = {
    language,
    setLanguage,
    checked,
    setChecked,
  };

  return (
    <MyContext.Provider value={stateAndFunctions}>
      { children }
    </MyContext.Provider>
  );
}

Provider.propTypes = {
  children: PropTypes.node.isRequired,
};
